
import Vue from "vue";
import { castCardSize, castType, castTypeArray, ICast } from "@/types/cast";
import { storage } from "@/plugins/firebase";
import { getDownloadURL, ref } from "firebase/storage";
export default Vue.extend({
  data(): {
    imgSrcUrl: string;
  } {
    return {
      imgSrcUrl: "",
    };
  },
  methods: {
    onClick() {
      this.$emit("onClickCard", this.castData);
    },
    getCastType(): castType {
      return this.castData.castType;
    },
    isEconomy(): boolean {
      return this.getCastType() == castTypeArray.Economy;
    },
    isStandard(): boolean {
      return this.getCastType() == castTypeArray.Standard;
    },
    isPremium(): boolean {
      return this.getCastType() == castTypeArray.Premium;
    },
    isStandardSize(): boolean {
      return this.cardSize == castCardSize.Standard;
    },
    isMiniSize(): boolean {
      return this.cardSize == castCardSize.Mini;
    },
    getFee(castType: castType):string{
      if(castType == castTypeArray.Premium){
        return '6,300'
      }
      if(castType == castTypeArray.Standard){
        return '4,125'
      }
      if(castType == castTypeArray.Economy){
        return '2,625'
      }
      return ''
    }
  },
  watch: {
    castData: {
      handler: async function (value) {
        if (!value.imgSrcList[0]) {
          this.imgSrcUrl = "";
          return;
        }
        const url = await getDownloadURL(ref(storage, value.imgSrcList[0]))
          .then(function (url) {
            return url;
          })
          .catch(function (error) {
            console.log(error);
            return "";
          });

        this.imgSrcUrl = url;
      },
      deep: true,
      immediate: true,
    },
  },
  props: {
    castData: {
      type: Object as () => ICast,
    },
    cardSize: {
      type: String,
      default: "standard",
    },
  },
});
